const KeenSlider = window.KeenSlider

const { setInitialised, useCounter, useProgress } = window.BAO.Carousel.plugins

class ProductMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.setupCarousel = this.setupCarousel.bind(this)
    this.listeners.add(document, 'refreshMediaGallery', this.setupCarousel)
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: `${this.els.slide.selector}:not([aria-hidden="true"])`,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 768px)': {
            disabled: true,
          },
        },
      },
      [
        setInitialised(),
        useCounter({
          counter: this.els?.counter?.element,
        }),
        useProgress({
          container: this.els?.progress?.element,
          progressbar: this.els?.progressbar?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
